module.exports = __webpack_public_path__ + "img/trial-to-basic-group-mobile.3ff56889.svg";